<template>
    <div class="foodSafety">
        <div class="header">食品检测</div>
        <div class="nav">
            <div class="nav_word">食品安全检测</div>
            <div><img src="../assets/images/yao.png" alt="" class="nav_png" /></div>
        </div>
        <div class="price">
            <div class="subtitle">
                <span>检测日期</span>
                <span>商品名称</span>
                <span>检测项目</span>
                <span>检测结果</span>
            </div>
            <div class="subtitles" v-for="(item, index) in list" :key="index">
                <span>{{ item.testDate }}</span>
                <span>{{ item.goodsName }}</span>
                <span>{{ item.testItem }}</span>
                <span>{{ item.testResult }}</span>
            </div>
        </div>
        <div class="back" @click="back">
            <img src="../assets/images/back.png" alt="" class="back_png">
            <span class="back_word">返回</span>
        </div>
    </div>
</template>
<script>
import { safety } from "@/api/home"
export default {
    data() {
        return {
            list: [],
            tenantId: '',
            pageNum: 1,
            pageSize: 999
        }
    },
    created() {
      this.tenantId= this.$route.params.tenantId
    },
    mounted() {
        this.getAll()
    },
    methods: {
        getAll() {
            safety({
                marketId: this.tenantId,
                pageNum: this.pageNum,
                pageSize: this.pageSize
            }).then(res => {
                this.list = res.data.list


            }).catch(err => {
                //  alert(err)
            })

        },
        back() {
            this.$router.go(-1)
        }
    }
}
</script>
<style lang="less" scoped>
.foodSafety {

    .header {
        height: 0.9rem;
        line-height: 0.9rem;
        font-size: 0.32rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 400;
        color: #3E3E3E;
        background: #FFFFFF;
        opacity: 1;
    }

    .nav {
        height: 3.32rem;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 0.38rem;
        background: linear-gradient(180deg, rgba(34, 110, 217, 0.22) 0%, #FFFFFF 100%);

        .nav_word {
            height: 0.5rem;
            font-size: 0.4rem;
            font-weight: bold;
            color: #3D3D3D;
            line-height: 0.5rem;
            letter-spacing: 0.01rem;
            margin-top: 1rem;
        }

        .nav_png {
            width: 2.2rem;
            height: 2.2rem;
            margin-top: 0.2rem;
            // float: right;
            // margin: 0.3rem 0.46rem 0 0;
        }
    }

    .price {
        margin-top: -0.82rem;
        //height:7.5rem;
        //   background: #FFFFFF;
        border-radius: 0.32rem 0.32rem 0rem 0rem;
        opacity: 1;
        box-sizing: border-box;
        padding: 0 0.3rem;
        clear: both;

        .subtitle {
            // display: flex;
            // justify-content: flex-start;
            font-size: 0.32rem;
            font-size: 0.32rem;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 400;
            color: #999999;
            height: 1rem;
            line-height: 1rem;
            float: left;
            width: 100%;

            span {

                display: inline-block;
                width: 25%;
            }
        }

        .subtitles {
            float: left;
            // display: flex;
            // justify-content: space-between;
            font-size: 0.32rem;
            font-size: 0.32rem;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 400;
            color: #3E3E3E;
            height: 1rem;
            line-height: 1rem;
            border-bottom: 0.02 solid #F0F0F0;
            width: 100%;

            span {

                display: inline-block;
                width: 25%;
            }
        }


    }

    .back {
        width: 1.74rem;
        height: 0.92rem;
        line-height: 0.92rem;
        background: #FFFFFF;
        box-shadow: 0rem 0.12rem 0.26rem -0.02rem #DCDCDC;
        border-radius: 0.2rem;
        position: fixed;
        bottom: 0.68rem;
        left: 0.24rem;
        z-index: 99;

        .back_png {
            width: 0.3rem;
            height: 0.44rem;
            vertical-align: middle;
            margin-top: -0.1rem;
        }

        .back_word {
            font-size: 0.32rem;
            font-weight: 400;
            color: #3D3D3D;
            margin-left: 0.1rem;
        }
    }
}
</style>